import type { TFunction } from "i18next";
import { Currency, FrameworkAgreementDto, FrameworkAgreementStatus, NeedDto } from "../../autogen/bff-api";
import { activePanel, startRefusal } from "../framework-agreement/callOffAvailability";

export type CallOffForm = "miniCompetition" | "directCallOff";

export const allowedForms = (t: TFunction, agreement: FrameworkAgreementDto): CallOffForm[] => {
  if (agreement.status !== FrameworkAgreementStatus.Active) return [];
  const forms: CallOffForm[] = [];
  if (
    agreement.allowsMiniCompetitions &&
    agreement.mayOpenMiniCompetition &&
    startRefusal(t, agreement, { startsMiniCompetition: true }) === null
  ) {
    forms.push("miniCompetition");
  }
  if (
    agreement.allowsDirectAward &&
    agreement.mayCreateCallOff &&
    activePanel(agreement).length > 0 &&
    startRefusal(t, agreement) === null
  ) {
    forms.push("directCallOff");
  }
  return forms;
};

export const startableAgreements = (t: TFunction, agreements: FrameworkAgreementDto[]): FrameworkAgreementDto[] =>
  agreements.filter((agreement) => allowedForms(t, agreement).length > 0);
export const needValueIn = (need: NeedDto, currency: Currency): number | null => {
  const procurerValue = need.procurerAssessment?.value;
  if (procurerValue != null) return currency === Currency.Nok ? procurerValue : null;
  const estimated = need.estimatedValue;
  if (estimated?.value == null) return null;
  return estimated.currency === currency ? estimated.value : null;
};
